export default __webpack_public_path__ + "static/media/down.0a5c3740.svg";